module.exports = __webpack_public_path__ + "1_0_57/img/backspace.7f99dabe.svg";